/**
 * Internal dependencies
 */

import { default as pencil } from './pencil';
export default pencil;
//# sourceMappingURL=edit.js.map